export const Roles = {
  User: "User",
  Admin: "Admin",
  ComplianceReportAdmins: "ComplianceReportAdmins",
  PolicyAdmins: "PolicyAdmins",
  PolicyViewers: "PolicyViewers",
  AccessControlViewers: "AccessControlViewers",
} as const;

export type Role = typeof Roles[keyof typeof Roles];

export const RoleLabels: Record<Role, string> = {
  [Roles.User]: "Compliance Report Viewers",
  [Roles.Admin]: "Access Control Admins",
  [Roles.ComplianceReportAdmins]: "Compliance Report Admins",
  [Roles.PolicyAdmins]: "Policy Admins",
  [Roles.PolicyViewers]: "Policy Viewers",
  [Roles.AccessControlViewers]: "Access Control Viewers",
};
